/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';

function CardHeaderCustom({ title, textRight, onPress }) {
  return (
    <View style={styles.customHeader}>
      <SociollaText type="medium" style={styles.customHeaderText}>
        {title}
      </SociollaText>
      {textRight ? (
        <TouchableOpacity activeOpacity={0.8} onPress={onPress}>
          <SociollaText style={styles.customHeaderTextRight}>
            {textRight}
          </SociollaText>
        </TouchableOpacity>
      ) : (
        false
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  customHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    paddingBottom: 15,
  },
  customHeaderText: { fontSize: 14 },
  customHeaderTextRight: { fontSize: 13, color: Colors.blue0 },
});

export default React.memo(CardHeaderCustom, (prev, next) => prev == next);
